/** @flow **/
import React from "react";
import { Dropdown, DropdownMenu, DropdownToggle, Checkbox } from "../";
import "./checkbox-menu.style.scss";

type MenuItems = $Exact<{
  label: string,
  handler: () => void,
}>;

type Props = $Exact<{
  dropdownItems: Array<MenuItems>,
  position?: "left" | "right",
  label?: string,
}>;

type State = $Exact<{
  dropdownOpen: boolean,
}>;

export class CheckboxMenu extends React.Component<Props, State> {
  state = {
    dropdownOpen: false,
  };

  toggle = (event: SyntheticMouseEvent<HTMLElement>) => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  clickHandler = (event: SyntheticMouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    return (
      <div className="dropdown-extended">
        <Dropdown
          disabled={false}
          isOpen={this.state.dropdownOpen}
          toggle={this.toggle}
          className={"menu"}
        >
          <DropdownToggle
            disabled={false}
            tag="span"
            onClick={this.clickHandler}
            data-toggle="dropdown"
            aria-expanded={this.state.dropdownOpen}
          >
            <div className="dropdown-button-label menu">
              <Checkbox
                id="details-select-all"
                checked={false}
                disabled={false}
                onClick={this.clickHandler}
                onChange={this.clickHandler}
                label={this.props.label}
              />
            </div>
          </DropdownToggle>
          <DropdownMenu
            onClick={this.toggle}
            className="dropdown-menu-extended"
            right={this.props.position !== "right"}
          >
            {this.props.dropdownItems.map((item, indx) => (
              <div
                key={`${item.label}-${indx}`}
                className={"dropdown-item-wrapper text-primary"}
                onClick={item.handler}
              >
                {item.label}
              </div>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default CheckboxMenu;
